import { Divider } from "antd";
import _ from "lodash";
import moment from "moment";
import mainClasses from "pages/agent-chat-ticket/AgentChatTicket.module.css";
import { useMemo } from "react";

import IconChatAvatar from "./IconChatAvatar";

const ChatMessages = ({ chatLog }) => {
  console.log("chatLog", chatLog);
  const listMessagesGroupByDate = useMemo(() => {
    if (!chatLog?.message) return null;
    const sortedMessages = [...chatLog.message].sort(
      (a, b) => new Date(a.created_at) - new Date(b.created_at)
    );
    return _(sortedMessages)
      .groupBy((item) =>
        new Date(item.created_at).toLocaleString("vi-VN", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      )
      .value();
  }, [chatLog]);

  return (
    chatLog && (
      <div className={mainClasses.chatLog__root}>
        <div className={mainClasses.chatLog__content}>
          {listMessagesGroupByDate &&
            Object.entries(listMessagesGroupByDate).map(([key, values]) => (
              <div key={key}>
                <Divider className={mainClasses.chatLog__dividerDate}>
                  <span className={mainClasses.labelSmall}>{key}</span>
                </Divider>
                {values?.map((message) => renderMessage(message, chatLog))}
              </div>
            ))}
        </div>
      </div>
    )
  );
};

const renderMessage = (message, chatLog) => {
  let messageBody;
  switch (message.type) {
    case "text":
      messageBody = message.text;
      break;

    case "link":
      messageBody = (
        <a target="_blank" rel="noopener noreferrer" href={message.text}>
          {message.text}
        </a>
      );
      break;

    case "image":
      messageBody = (
        <img
          src={message.text}
          alt=""
          className={mainClasses.chatLog__messageImage}
        />
      );
      break;

    case "video":
      messageBody = (
        <video width="320" controls>
          <source src={message.text} />
        </video>
      );
      break;

    case "voice":
      messageBody = (
        <audio ref="audio" src={message.text} controls autoPlay={false} />
      );
      break;

    case "location":
      // TODO
      break;

    case "file":
      messageBody = (
        <a target="_blank" rel="noopener noreferrer" href={message.text}>
          {message.text}
        </a>
      );
      break;

    default:
      break;
  }

  const fullname =
    message.usertype === "sender"
      ? chatLog.sender_info.full_name
      : chatLog.receiver_info.full_name;

  return messageBody !== undefined ? (
    <MessageWrapper
      time={message.created_at}
      fullname={fullname}
      type={message.usertype}>
      {messageBody}
    </MessageWrapper>
  ) : null;
};

const MessageWrapper = ({ children, type, avatar, time, fullname }) => (
  <div
    className={`${mainClasses.chatLog__messageWrapper}${
      type === "sender" ? " left" : " right"
    }`}>
    <div className={mainClasses.chatLog__messageInfo}>
      <IconChatAvatar isCustomer={type === "sender"} />

      <span>{fullname}</span>

      <span>{time && moment(time).format("HH:mm:ss")}</span>
    </div>
    <div
      className={mainClasses.chatLog__messageContent}
      style={{
        backgroundColor: type === "sender" ? "#d7dbd8" : "#fedb8f",
      }}>
      {children}
    </div>
  </div>
);

export default ChatMessages;
